import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetworkSetupService {
  setupData = [];
  handleSetupDataCollection = new BehaviorSubject<Array<any>>([]);
  constructor() {}
  addSetupData(data) {
    this.setupData.push(data);
  }

  getSetupData() {
    return this.setupData;
  }
}
